const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const modifyMainPhoneActions = require('actions/contactCenter/modifyMainPhone/modifyMainPhone');

import ModifyMainPhoneView from 'components/contactCenter/modifyMainPhone/modifyMainPhoneView';

class ModifyMainPhoneContainer extends React.Component {
    render() {
        return <ModifyMainPhoneView {...this.props} />;
    }
}

ModifyMainPhoneContainer.propTypes = {
    immModifyMainPhone: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setMainPhone: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    confirmModifyMainPhone: PropTypes.func.isRequired,
    requestContactPhoneData: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    immModifyMainPhone: state.modifyMainPhone,
    immProfileFields: state.profile
});

module.exports.constructor = ModifyMainPhoneContainer;
module.exports.ModifyMainPhoneContainer = connect(
    mapStateToProps,
    {
        setVisibleStep: modifyMainPhoneActions.setVisibleStep,
        validateStep: modifyMainPhoneActions.validateStep,
        showCancelModal: modifyMainPhoneActions.showCancelModal,
        reset: modifyMainPhoneActions.reset,
        confirmModifyMainPhone: modifyMainPhoneActions.confirmModifyMainPhone,
        requestContactPhoneData: modifyMainPhoneActions.requestContactPhoneData,
        setMainPhone: modifyMainPhoneActions.setMainPhone
    }
)(ModifyMainPhoneContainer);
